





















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { CheckboxInput, TextInput } from '@/components/FormInputs/FormInputs';

@Component({
	components: {
		CheckboxInput,
		TextInput,
	}
})
export default class AffirmationView extends Vue {
	private isLoading: boolean = true;

	public get filingType(): string { return this.getFormDataKey('Claim.FilingType') }

	public beforeMount() {
		this.$store.commit('InterviewModule/updateIsInterviewConfirmed', false);
	}

	public async created() {
		this.$store.commit('InterviewModule/updatePageName', 'Affirmation');
		if (this.$route.params.refreshFormData) {
			await this.$store.dispatch('InterviewModule/getFormData', 'Affirmation');
		}
		this.isLoading = false;
	}
}
